export default __webpack_public_path__ + "static/media/cold-tea-berry.1eac9ba0.png";